export enum VitalSignCareElementName {
    BloodPressure = "BloodPressure",
    BloodPressureSystolic = "BloodPressureSystolic",
    BloodPressureDiastolic = "BloodPressureDiastolic",
    BodyMassIndex = "BodyMassIndex",
    WaistCircumference = "WaistCircumference",
    Height = "Height",
    Weight = "Weight",
    HeartRate = "HeartRate"
}
